<template>
  <div class="box-detail-item">
    <div class="z">
      <!--start preview-->
      <div class="bordered">
        
        
        <router-link v-bind:to="`/iniciativa/${box.id}`">
          <div class="box-header has-background-danger">
            <div class="box-header-button zhas-text-black">            
              {{ box.user ? box.user.name : '-' }}
            </div>
          </div>

        
          <div class="box-body">
            <p class="box-name">
              {{ box.name }}
            </p>
            <p class="box-description block-with-text">{{ box.description | ellipsizeText}}</p>
            <p class="box-description box-demand block-with-text">{{ box.demand | ellipsizeText2}}</p>
          </div>

          <div class="info-row zinfo-row-first info-row-br">
            <div class="columns is-marginless more-info is-desktop is-multiline">
              <div class="column column-download is-full" v-if="box.city">
                <i class="material-icons access_time person">place</i>
                {{ box.city ? box.city : ''  }}
              </div>
              <!-- <div class="column column-download is-full">
                <i class="material-icons access_time">access_time</i>
                  {{ box.createdOn.seconds | formatDate}}
              </div> -->
              <div class="column column-download is-full ">
                <i class="material-icons access_time">group_work</i>
                {{ box.scope | scopeDescription }}
              </div>

              <div class="column column-download column-bordered is-full text-center">
                <button v-if="box.demand != ''" class="button is-danger">Vull aportar</button>
                <button v-if="box.demand == ''" class="button is-danger">Vull contactar</button>                
              </div>

            </div>

        </div>
        </router-link>
        

        </div>
      </div>
    </div>
    <!-- <router-link v-bind:to="`/iniciativa/${box.id}`">
      {{ box.name }}
      - {{ box.id }}
      - {{ box.state }}
      </router-link>
    <pre>
      {{ box }}
    </pre>-->
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import { scopeDescription } from '../services/descriptions.filters';

export default {
  props: {
    box: Object
  },
  data() {
    return {
      palette: [
        // http://colormind.io/
        "#64D19E",
        "#DCE7AC",
        "#F8974F",
        "#E66A57",
        "#B2424E"
      ]
    };
  },
  computed: {
    ...mapState(["userBoxes", "currentUser", "downloadedBoxes"]),
    canAccess() {
        return this.currentUser != null && this.userBoxes.find(u => u.id == this.box.id) != null || this.downloadedBoxes.find(u => u.id == this.box.id) != null || this.box.userId == this.currentUser.uid
    }
  },
  methods: {
    bgColor() {
      return this.palette[Math.floor(Math.random() * 4)]
      //return '#49C4AF';
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "";
      }
      return moment.unix(val).format("DD/MM/YYYY")
    },
    trimLength(val) {
      if (val.length < 200) {
        return val;
      }
      return `${val.substring(0, 200)}...`;
    },
    firstInitial(val) {
      if (val && val.length > 0) {
        return val.substring(0,1);
      }
      return ``;
    },
    ellipsizeText(text) {
      if (text.length > 80) {
        text = text.substring(0, 80) + '...'
      }
      return text
    },
    ellipsizeText2(text) {
      if (text.length > 50) {
        text = text.substring(0, 50) + '...'
      }
      return text
    },
    formatReview(val) {
      if (!val || val == '-') {
        return "-";
      }
      return Math.round(val * 10) / 10
    }

  }
};
</script>
<style scoped>
.access_time-col{
  color: rgb(114, 116, 117);
  color: #fff;
  font-size: 16px;
  /* font-family: 'Varela Round'; */
}
.column-access_time-col{
  margin-top: 6px;
}
.access_time{
  vertical-align: -5px;
}
.round{
  background-color: #a3a3a3;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  font-weight: bold;
  color:#fff;
  text-transform: uppercase;
  /* font-family: 'Varela Round'; */
  margin-right: 4px;
}
.more-info{
  color: #a3a3a3;
  /* font-family: 'Varela Round'; */
  /* font-weight: bold; */
}
a.link-to-user{
  color: #a3a3a3;
}
a.link-to-user:hover{
  color: #0a0a0a;
}
.column-download i{
  font-size: 34px;
  vertical-align: -12px;
  margin-right: 4px;
}
a.button.button-detalls{
color:#fff;
/* font-family: 'Varela Round'; */


}

@media screen and (max-width: 742px) {

a.button.button-detalls{
    margin-bottom: 15px;
}
}

.info-row{
  border-top:1px solid #f1f1f1;background-color: #f9f9f9;
}
.bordered {
  border: 1px solid #f1f1f1;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  border-radius: 2px;
}
.box-header{
  position:relative;
  height:70px;
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}
.box-header .has-background-danger{
  background-color: #f14668 !important;
}
.box-header-button{
  height: 70px;
  line-height: 70px;
  padding: 0 20px 0 20px;
  color:#fff;
  font-family: 'Varela Round';
  font-family: 'Montserrat';  
  font-weight: 500;
}
.box-body{
  padding:20px
}
.box-body a{
color: #727475;
font-size:20px;
margin-bottom:20px;
/* font-family:'Varela Round' */
}
.box-body{
  min-height: 190px;
}
.box-body p.box-description{
  color: #a3a3a3; 
  font-size:16px; 
  height: auto;
  line-height:30px;
  margin-top: 10px;
  font-family: 'Montserrat';
}
@media screen and (max-width: 742px) {
  .box-body p.box-description{
      height: auto;
  }
}

.box-body .tag{
  vertical-align: 4px;
  margin-left: 4px;
}
/* styles for '...' */
.block-with-text {
  height: 3.6rem;
}
.person{
  margin-right: 13px;
}
.box-name{
  font-size: 20px;
  color:#363636;
  font-family: 'Varela Round';
}
.info-row-br{
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
}
.column-bordered{
  border-top: 1px solid #f1f1f1;
}
.box-body p.box-demand{
  color: #363636;
}
</style>



// WEBPACK FOOTER //
// src/components/BoxItemDetail.vue